import QRCode from "qrcode";

export function shareLinkFor(id) {
  const { origin, pathname, search } = location;
  return `${origin}${pathname}${search}#local=${encodeURIComponent(id)}`;
}

export async function qrDataUrl(text) {
  return QRCode.toDataURL(text, {
    width: 520,
    margin: 2,
    errorCorrectionLevel: "M",
    color: { dark: "#182033", light: "#ffffff" },
  });
}

export async function shareCurrentFile(record, link) {
  const file = new File([record.blob], record.name, { type: record.type || "application/octet-stream" });
  const shareData = {
    title: record.name,
    text: `分享文档：${record.name}`,
    files: [file],
    url: link,
  };
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    await navigator.share(shareData);
    return;
  }
  if (navigator.share) {
    await navigator.share({ title: record.name, text: shareData.text, url: link });
    return;
  }
  throw new Error("当前浏览器不支持系统分享");
}
